import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { get_branch_ekyc_assignment } from "../../services/projectApi";
import { formatDate } from "../../utils/date_utils";
import CustomModal from "../../components/UiComponent/Modal";
import EkycAssignmentForm from "./EkycNewAssignment.js";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import BasicTable from "../../components/UiComponent/customTable";
import { GrView, GrStatusGoodSmall } from "react-icons/gr";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";
const EKYCAssignment = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = GetUserInfo();
  const user_branch = user?.employee?.branch_id;
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleButtonSubmit = () => {
    handleCloseModal();
  };
  const getempEkycAssignmentQuery = useQuery(
    ["getbranchempekycAssignment"],
    () => get_branch_ekyc_assignment(user_branch)
  );
  const assignmentData = useMemo(() => {
    return getempEkycAssignmentQuery.data || [];
  }, [getempEkycAssignmentQuery.data]);

  if (getempEkycAssignmentQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getempEkycAssignmentQuery.isError) {
    return <div>Error: {getempEkycAssignmentQuery.error.message}</div>;
  }

  const EkycAssignment = assignmentData?.data;

  const addNewEkycAssignment = (event, id) => {
    event.preventDefault();
    handleShowModal();
  };

  const ekycTableColumns = [
    {
      header: "Name",
      accessor: "first_name",
      accessorKey: "first_name",
      cell: (row) => (
        <div className="data-content">
          <p className="m-0 text-secondary small">
            {row.row.original.first_name} {row.row.original.father_name}
          </p>
          <span className="m-0 text-secondary small">
            {" "}
            {row.row.original.phone}
          </span>
        </div>
      ),
    },

    {
      header: "Device",
      accessorKey: "device_name",
      cell: (row) => (
        <div className="data-content">
          <p className="m-0 small">{row.row.original.device_name}</p>
        </div>
      ),
    },
    {
      header: "serial_number",
      accessorKey: "serial_number",
      cell: (row) => (
        <div className="data-content">
          <p className="m-0 small">{row.row.original.serial_number}</p>
        </div>
      ),
    },

    {
      header: "username",
      accessorKey: "username",
      cell: (row) => (
        <div className="data-content">
          <p className="m-0 small">{row.row.original.username}</p>
        </div>
      ),
    },
  ];

  return (
    <div>
      <BasicTable
        data={EkycAssignment}
        columns={ekycTableColumns}
        title={`ekyc_assignment_list`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => addNewEkycAssignment(e, user_branch)}
          >
            {t("add_new_assignment")}
          </Button>
        }
      />
      <CustomModal
        show={showModal}
        title="new_ekyc_assignment"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={
          <EkycAssignmentForm
            onSubmitButton={handleButtonSubmit}
            parentID={user_branch}
          />
        }
      />
    </div>
  );
};
export default EKYCAssignment;
